var SocialMediaMonitorComponent = /** @class */ (function () {
    function SocialMediaMonitorComponent() {
    }
    SocialMediaMonitorComponent.prototype.ngOnInit = function () {
    };
    return SocialMediaMonitorComponent;
}());
export { SocialMediaMonitorComponent };



// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.ts.pre-build-optimizer.js